import { useEffect, useState } from 'react';
import { customersService } from '../services/customers.service';

/* Module-level cache — shared across all hook instances */
const customerCache = new Map();

const useCustomerName = (customerId) => {
  const [name, setName] = useState(null);
  const [loading, setLoading] = useState(Boolean(customerId));
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!customerId) {
      setLoading(false);
      return;
    }

    if (customerCache.has(customerId)) {
      const cached = customerCache.get(customerId);
      setName(cached);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(false);

    customersService
      .getCustomer(customerId)
      .then((customer) => {
        if (cancelled) return;
        const resolved =
          [customer?.firstName, customer?.lastName].filter(Boolean).join(' ') || customerId;
        customerCache.set(customerId, resolved);
        setName(resolved);
      })
      .catch(() => {
        if (cancelled) return;
        setError(true);
        setName(customerId);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [customerId]);

  return { name: name ?? customerId, loading, error };
};

export { customerCache };
export default useCustomerName;
